import { useParams, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import HtmlHead from '../UI/Head/HtmlHead';
import { RepairyBookingV2URL, useApi } from '../../util/lib';

const getCode = (value) => {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  return (
    value.code ||
    value.bookingLeadCode ||
    value.quoteCode ||
    value.id
  );
};

export const BookingRescue = () => {
  const api = useApi();
  const { code } = useParams();
  const location = useLocation();
  const [pristine, setPristine] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const redirect = async () => {
      try {
        if (!pristine) return;
        setPristine(false);

        const response = await api({
          method: 'get',
          responseType: 'json',
          url: `/campaigns/abandoned-cart/${code}`,
        });

        const data = response && response.data ? response.data : {};
        if (!data.success) {
          throw new Error('Failed to fetch abandoned cart campaign');
        }

        const workshopCode = data.workshopCode;
        if (!workshopCode) {
          throw new Error('Missing workshopCode in abandoned cart response');
        }

        const bookingLeadCode = getCode(data.bookingLead);
        const quoteCode = getCode(data.quote);

        const bookingFormBaseUrl = RepairyBookingV2URL
          .replace(/\/bookingform\/?$/, '')
          .replace(/\/+$/, '');

        let redirectPath = '';
        if (bookingLeadCode) {
          redirectPath = `${workshopCode}/cart/${bookingLeadCode}`;
        } else if (quoteCode) {
          redirectPath = `${workshopCode}/quote/${quoteCode}/status`;
        } else {
          throw new Error('Missing bookingLead or quote in abandoned cart response');
        }

        const queryString = location.search;
        const redirectUrl = queryString
          ? `${bookingFormBaseUrl}/${redirectPath}${queryString}`
          : `${bookingFormBaseUrl}/${redirectPath}`;

        window.location.href = redirectUrl;
      } catch (error) {
        console.error(error);
        setError(true);
      }
    };

    redirect();
  }, [api, code, location.search, pristine]);

  return (
    <>
      <HtmlHead repairy />
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}>
        {error ? (
          <p>
            Opps! Seems like we cant provide you a service now.
            Please contact support if problem persists
          </p>
        ) : (
          <p>Redirecting...</p>
        )}
      </div>
    </>
  );
};
